import React from "react"
import BlockContent from "@sanity/block-content-to-react"

import YoutubeEmbed from "~components/youtube/youtube"

const BlockRenderer = (props) => {
  const { style = "normal" } = props.node

  if (style === "h1") return <h1 className="">{props.children}</h1>
  if (style === "centered") return <p style={{ textAlign: "center" }}>{props.children}</p>
  if (style === "rightAligned") return <p style={{ textAlign: "right" }}>{props.children}</p>

  // normal and any other styles fall back to default
  return BlockContent.defaultSerializers.types.block(props)
}

const serializers = {
  types: {
    block: BlockRenderer,
    youtube: (value) => {
      if (value.node && value.node.youtubeOverride) {
        return (<div className="mb--1 mt--1"><YoutubeEmbed embed={value.node.youtubeOverride} /></div>)
      } else {
        return <div></div>
      }
    }
  },
  marks: {
    externalLink: ({ mark, children }) => {
      // Read https://css-tricks.com/use-target_blank/
      const { blank, href } = mark
      return blank ? (
        <a href={href} target="_blank" rel="noopener noreferrer" className="inline_link">
          {children}
        </a>
      ) : (
        <a href={href}>{children}</a>
      )
    },
  },

}

const PortableText = ({ blocks }) => (
  <BlockContent blocks={blocks} serializers={serializers} />
)

export default PortableText
